<template>
    <div class="gpt-digital-human">
        <video v-if="video" ref="video" :src="video" muted @timeupdate="playing" @ended="resume"></video>
        <div class="status">
        </div>
    </div>
</template>

<script>
import { FUPCMPlayer } from '@/aispeech/sdk/fu_audio_player/pcm_player';
import HUMAN_AISPEECH_CONFIG from '@/app/constant/HUMAN_AISPEECH_CONFIG.js';
export default {
    name: 'gpt-digital-human',
    data () {
        let currentStatus = null; // 当前状态
        let speechPlayers = []; // 分段播放时，所有的段落
        let currentPlayerIdx = -1; // 分段播放时，当前播放的段落索引
        return { currentStatus, speechPlayers, currentPlayerIdx };
    },
    props: {
        /**
         * 视频
         */
        video: {
            type: String,
            default: null
        },

        /**
         * 待机的播放范围
         */
        standbyRange: {
            type: Array,
            default: null
        },

        /**
         * 演讲的播放范围
         */
        speekRange: {
            type: Array,
            default: null
        },

        /**
         * 声音类型
         */
        voiceType: {
            type: String,
            default: 'AISpeech'
        },

        /**
         * 语音ID
         */
        voiceId: {
            type: [Number, String],
            default: undefined
        }
    },
    mounted () {
        this.currentStatus = 'standby';
        this.videoPause();
    },
    methods: {
        /**
         * 播放一段文本
         */
        speekText (text) {
            text = text || this.text;
            let { voiceType, voiceId, speek, standby } = this;
            let options = { voiceType, voiceId, prepareCallback: null, playCallback: speek, pauseCallback: standby };

            // 检查文本长度
            if (text.length <= 20) {
                // 20个字以内的文本，直接播放
                let player = this.speech(text, options);
                this.speechPlayers = [player];
                this.currentPlayerIdx = -1;
                player.init().then(() => { player.play(); });// 初始化，然后播放
            } else {
                // 20个字以上的文本，分段播放
                let textArr = text.split(/[,，。？！；：\n]/);
                let speechPlayers = [];
                textArr.forEach((item, idx) => {
                    if (item && item.trim().length > 0) {
                        options.playCallback = this.videoPlay; // 播放完一段后，继续播放下一段
                        options.pauseCallback = this.speekNext; // 播放完一段后，继续播放下一段
                        let player = this.speech(item, options);

                        player.speechPlayerIdx = idx; // 记录段落索引
                        speechPlayers.push(player);
                        if (idx === 0) {
                            player.init().then(() => { this.speekNext(); });// 初始化，然后播放第一段
                        } else {
                            player.init(); // 其他初始化
                        }
                    }
                });
                this.speechPlayers = speechPlayers;
                this.currentPlayerIdx = -1;
            }
        },

        /**
         * 数字人播报
         */
        speek () {
            this.currentStatus = 'speek';
            this.videoPlay();

            /**
             * @event speek
             * 数字人开始播报
             */
            this.$emit('speek');
        },

        /**
         * 数字人待机
         */
        standby () {
            this.currentStatus = 'standby';
            this.videoPause();
            this.speechPlayers && this.speechPlayers.forEach((item) => item.stop());
            this.speechPlayers = [];

            /**
             * @event standby
             * 数字人待机
             */
            this.$emit('standby');
        },

        /**
         * 分段播放时，播放下一段
         */
        speekNext () {
            if (this.currentPlayerIdx < this.speechPlayers.length - 1) {
                if (this.currentPlayerIdx === -1) {
                    // 第一个段落开始播放
                    this.currentStatus = 'speek';
                    this.videoPlay();
                    /**
                     * @event speek
                     * 数字人开始播报
                     */
                    this.$emit('speek');
                }

                this.currentPlayerIdx++;
                this.speechPlayers[this.currentPlayerIdx].play();
            } else if (this.speechPlayers.length > 0) {
                // 播放完毕，待机
                this.standby();
            }
        },

        /**
         * 视频播放完时，循环播放
         */
        resume () {
            if (this.currentStatus === 'standby') {
                this.videoPause();
            } else if (this.currentStatus === 'speek') {
                this.videoPlay();
            }
        },

        /**
         * 监测播放状态
         */
        playing () {
            let video = this.$refs.video;
            if (this.currentStatus === 'standby' && this.standbyRange && video.currentTime > this.standbyRange[1]) {
                this.videoPause();
            } else if (this.currentStatus === 'speek' && this.speekRange && video.currentTime > this.speekRange[1]) {
                this.videoPlay();
            }
        },

        /**
         * 视频播放
         */
        videoPlay () {
            let video = this.$refs.video;
            let range = this.speekRange || [ 0, video.duration ];
            video.currentTime = range[0];
            video.play();
        },

        /**
         * 视频待机
         */
        videoPause () {
            let video = this.$refs.video;
            let range = this.standbyRange || [ 0, video.duration ];
            video.currentTime = range[0];
            video.play();
        },

        /**
         * 语音
         */
        speech (text, options) {
            if (!options.voiceType || options.voiceType === 'yjy') {
                return new Text2Speech(text, options); // 研究院
            } else if (options && options.voiceType === 'AISpeech') {
                return new AISpeech(text, options); // 思必驰
            } else {
                return new LocalSpeech(text, options); // 默认本地语音
            }
        }
    }
};

/**
 * 本地语音
 */
class LocalSpeech {
    constructor (text, options = {}) {
        this.text = text;
        if (options)Object.assign(this, options);
    }

    /**
     * 初始化音频
     */
    async init () {
        // 没有初始化过程
        if (this.prepareCallback) this.prepareCallback(); // 准备阶段的回调
    }

    /**
     * 播放
     */
    async play () {
        let utter = this.utter = new SpeechSynthesisUtterance();
        let voices = speechSynthesis.getVoices();
        let content = this.text;
        let voiceId = this.voiceId;
        if (!voiceId)voiceId = 1;
        if (typeof voiceId === 'string') {
            voiceId = parseInt(voiceId);
        }
        let voice = voices.filter(item => item.localService === true)[ voiceId ];
        utter.text = content;
        utter.voice = voice;

        if (this.playCallback) this.playCallback(); // 播放阶段的回调

        speechSynthesis.speak(utter);
        utter.onend = () => {
            if (this.pauseCallback) this.pauseCallback(); // 待机阶段的回调
        };
    }

    /**
     * 停止，释放资源
     */
    stop () {
        if (this.utter) {
            speechSynthesis.cancel(this.utter);
            this.utter = null;
        }
    }
}

/**
 * 调用模型的语音合成
 */
class Text2Speech {
    constructor (text, options = {}) {
        this.text = text;
        if (options)Object.assign(this, options);
        this.base64String = null;
    }

    /**
     * 初始化音频
     */
    async init () {
        let API_URL = '/models';
        let text2speechApi = API_URL + '/text2speech';
        // eslint-disable-next-line camelcase
        let task_id = 2;
        let content = this.text;
        let voiceId = this.voiceId || 'zh-CN-XiaoyiNeural';
        let payload = { task_id, content, voiceType: voiceId };
        let headers = { 'Content-Type': 'application/json' };
        let body = JSON.stringify(payload);

        let resp = await fetch(text2speechApi, { method: 'POST', body, headers });
        if (resp.status !== 200) {
            throw new Error(`文字转语音失败[${resp.status}]:${resp.statusText}`);
        }
        // 文字转语音结果
        let json = await resp.json();
        let base64String = json.result || '';

        this.base64String = base64String;
        if (this.prepareCallback) this.prepareCallback(); // 准备阶段的回调
        return base64String;
    }

    /**
     * 播放
     */
    async play () {
        let base64String = this.base64String;
        if (!base64String) {
            // 还没准备好，等待
            requestAnimationFrame(() => {
                this.play();
            });
            return;
        }

        if (this.playCallback) this.playCallback(); // 播放阶段的回调

        // 播放语音
        let url = 'data:audio/wav;base64,' + base64String;
        let audio = this.audio = new Audio();
        audio.src = url;
        audio.addEventListener('ended', () => {
            if (this.pauseCallback) this.pauseCallback(); // 待机阶段的回调
        });

        audio.play();
    }

    /**
     * 停止，释放资源
     */
    stop () {
        if (this.audio) {
            this.audio.pause();
            this.audio = null;
        }
    }
}

/**
 * 思必驰的语音合成
 */
class AISpeech {
    constructor (text, options = {}, config = {}) {
        this.text = text;
        options = options || {};
        config = config || {};
        Object.assign(this, options);

        this.config = {
            asrBuffer: 16384,
            sampleRate: 16000,
            channel: 1,
            sampleBit: 16,
            sampleByte: 16 / 8
        };
        this.config.voiceId = options.voiceId || 'gdfanfp'; // 默认语音
        Object.assign(this.config, HUMAN_AISPEECH_CONFIG); // 思必驰默认配置
        Object.assign(this.config, config);

        this.pcm = null; // pcm数据
    }

    /**
     * 初始化音频
     */
    init () {
        return new Promise((resolve, reject) => {
            let text = this.text;
            let { voiceId, productIdServer, apikey, sampleRate, channel, sampleByte } = this.config;
            let API_URL = '/aispeech';
            // let API_URL = 'https://tts.duiopen.com'; // 直接使用思必驰的服务
            let url = `${API_URL}/runtime/v2/synthesize?voiceId=${voiceId}&productId=${productIdServer}&apikey=${apikey}`;
            let timestamp = Date.parse(new Date());
            let json = {
                context: {
                    productId: productIdServer
                },
                request: {
                    requestId: timestamp,
                    audio: {
                        audioType: 'pcm',
                        sampleRate: sampleRate,
                        channel: channel,
                        sampleBytes: sampleByte
                    },
                    tts: {
                        text: text,
                        textType: 'text',
                        voiceId: voiceId,
                        speed: '1.0',
                        volume: 100,
                        enableRealTimeFeedback: true,
                        returnPhone: true
                    }
                }
            };
            var xhr = new XMLHttpRequest();
            xhr.open('POST', url, true);
            xhr.setRequestHeader('content-type', 'application/json');
            xhr.responseType = 'arraybuffer';
            xhr.onload = (e) => {
                let bytes = new Uint8Array(xhr.response);
                let hl = 0;
                let pt = 0;
                let pl = 0;
                let tl = 0;
                let pcm = [];
                let cur = '';
                let sux = '';
                let suxi = 0;
                let time = 0;
                let tmp = '';

                for (let i = 0; i < bytes.length; i++) {
                    let char = String.fromCharCode(bytes[i]);
                    if (char === 'A') {
                        let char1 = String.fromCharCode(bytes[++i]);
                        if (char1 === 'S') {
                            hl = bytes[++i];
                            pt = bytes[++i];
                            pl = (bytes[++i] << 8) | bytes[++i];
                            tl = bytes[++i];
                            ++i;
                            pl -= tl;

                            if (pt === 0) {
                                ++i;
                                pcm.push.apply(pcm, bytes.slice(i, i + pl));
                                i = i + pl - 1;
                            } else if (pt === 1) {
                                while (pl > 0) {
                                    pl--;
                                    let tc = String.fromCharCode(bytes[++i]);
                                    if (tc === ' ') {
                                        suxi++;
                                        if (cur !== tmp) {
                                            if (cur === '') {
                                                sux = '0.000 ';
                                            } else {
                                                time = (suxi * 5) / 1000;
                                                sux =
                                                    sux +
                                                    time.toFixed(3) +
                                                    ' ' +
                                                    cur +
                                                    '\n' +
                                                    time.toFixed(3) +
                                                    ' ';
                                            }
                                            cur = tmp;
                                        }
                                        tmp = '';
                                    } else {
                                        tmp += tc;
                                    }
                                }
                            }
                        }
                    }
                }
                if (cur !== '') {
                    time = (suxi * 5) / 1000;
                    sux = sux + time.toFixed(3) + ' ' + cur + '\n';
                }

                this.pcm = pcm;
                if (this.prepareCallback) this.prepareCallback(); // 准备阶段的回调
                resolve(pcm);
            };

            xhr.send(JSON.stringify(json));
        });
    }

    /**
     * 播放
     */
    async play () {
        let pcm = this.pcm;
        if (!pcm) {
            // 还没准备好，等待
            requestAnimationFrame(() => {
                this.play();
            });
            return;
        }

        // 播放器
        let audioPlayer = this.audioPlayer = new FUPCMPlayer({
            manul: false,
            encoding: '16bitInt', // PCM 格式
            channels: 1, // 声道数
            sampleRate: 16000 // 采样率
        });

        if (this.playCallback) this.playCallback(); // 播放阶段的回调
        audioPlayer.setRequestStop();
        audioPlayer.setOnEnd(() => {
            if (this.pauseCallback) this.pauseCallback(); // 待机阶段的回调
        });

        audioPlayer.feed(new Int16Array(new Uint8Array(pcm).buffer));
    }

    /**
     * 停止，释放资源
     */
    stop () {
        if (this.audioPlayer) {
            this.audioPlayer.interrupt();
            this.audioPlayer = null;
        }
    }
}
</script>
<style scoped lang="scss">
.gpt-digital-human {
    position: relative;
    width: 100%;
    height: 100%;
    video {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
}
</style>
